import React from "react";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const TikTok = ({ size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.06-2.82h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.6c.27 0 .53.04.78.12V9.66c-3.45-.46-6.47 2.22-6.47 5.64a5.7 5.7 0 0 0 11.39 0V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.26-1.48z" />
  </svg>
);
const Spotify = ({ size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.59 14.42a.62.62 0 0 1-.86.21c-2.35-1.44-5.3-1.76-8.79-.96a.62.62 0 1 1-.28-1.22c3.82-.87 7.09-.5 9.72 1.11a.62.62 0 0 1 .21.86zm1.23-2.74a.78.78 0 0 1-1.07.26c-2.69-1.65-6.79-2.13-9.97-1.17a.78.78 0 1 1-.45-1.49c3.63-1.1 8.15-.56 11.24 1.33a.78.78 0 0 1 .25 1.07zm.11-2.85C14.7 8.95 9.35 8.78 6.14 9.75a.94.94 0 1 1-.54-1.8c3.68-1.11 9.59-.9 13.35 1.33a.94.94 0 0 1-.96 1.61z" />
  </svg>
);

export default function SocialIcons({ className = "", size = 18, dark = false }) {
  const { c } = useContent();
  const items = [
    ["tiktok", c("social_tiktok"), TikTok],
    ["instagram", c("social_instagram"), Instagram],
    ["facebook", c("social_facebook"), Facebook],
    ["youtube", c("social_youtube"), Youtube],
    ["spotify", c("social_spotify"), Spotify],
  ].filter((x) => x[1]);
  if (!items.length) return null;
  const tone = dark
    ? "text-zinc-400 hover:bg-white/10 hover:text-white"
    : "text-zinc-500 hover:bg-zinc-100 hover:text-brand-violet";
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {items.map(([k, href, Icon]) => (
        <a key={k} href={href} target="_blank" rel="noreferrer" aria-label={k} data-testid={`social-${k}`}
          className={`flex h-9 w-9 items-center justify-center rounded-full transition ${tone}`}>
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}
